export default __webpack_public_path__ + "static/media/IOT2050.7f65a5ea.png";